// theme.js
import { createTheme } from '@mui/material/styles';

export const MUItheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#7A64EB',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#7A64EB',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': { color: '#7A64EB' },
        },
      },
    },

    MuiTabs: {
      styleOverrides: {
        indicator: { backgroundColor: '#7A64EB' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': { color: '#7A64EB' },
          color: 'rgba(0,0,0,0.6)',
          textTransform: 'none',
        },
      },
      defaultProps: { textColor: 'inherit' },
    },

    // Tables
    MuiTable: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },

    // GLOBAL Tooltip Configuration
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        placement: 'top',
        disableFocusListener: true,
        disableTouchListener: true,
        TransitionProps: { timeout: 0 },
        PopperProps: {
          keepMounted: true,
          disablePortal: false,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
            {
              name: 'flip',
              enabled: true,
            },
            {
              name: 'preventOverflow',
              enabled: true,
              options: {
                padding: 8,
              },
            },
          ],
        },
      },
      styleOverrides: {
        tooltip: {
          backgroundColor: '#fff',
          color: '#000',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
          fontSize: 14,
          border: '1px solid #333',
          maxWidth: 360,
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          lineHeight: 1.25,
        },
        arrow: {
          color: '#fff',
          '&:before': {
            boxShadow: '0 0 0 1px #333 inset',
          },
        },
      },
    },

    // Cards
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: 10,
          boxShadow: '1px 1px 4px 1px #E6E6E6',
          overflow: 'hidden',
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '16px',
        },
        title: {
          fontSize: '16px',
          fontWeight: 600,
        },
        action: {
          marginTop: 0,
          marginRight: 8,
        },
      },
    },

    MuiRadio: {
      styleOverrides: {
        root: { '& .MuiSvgIcon-root': { fontSize: 24 } },
      },
      defaultProps: { disableRipple: true },
    },

    // Buttons
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        root: {
          backgroundColor: '#7A64EB',
          color: '#ffffff',
          border: 'none',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: '#6B55E4',
            border: 'none',
          },
          '&:active': {
            backgroundColor: '#5F4BD8',
          },
          '&.Mui-disabled': {
            backgroundColor: 'rgba(122, 100, 235, 0.4)',
            color: '#ffffff',
          },
        },
      },
    },
  },
});
